import React, { useEffect, createRef,useRef, useState,useMemo } from 'react'
import { useTestMode } from '../Context/TextModeContext';
import  Uppermenu  from './Uppermenu';
import { Stats } from './Stats';
var randomWords=require('random-words')
 const TypingBox = () => {

  const inputRef=useRef(null)
  const {testTime}=useTestMode()
  const[currWordIndex,setCurrWordIndex]=useState(0);
  const[currCharIndex,setcurrCharIndex]=useState(0);
  const[countDown,setcountDown]=useState(testTime)//in sec
  const[testStart,settestStart]=useState(false)
  const[testEnd,settestEnd]=useState(false)
  const[intervalId,setintervalId]=useState(null)
  const[correctchars,setcorrectchars]=useState(0)
  const[correctwords,setcorrectwords]=useState(0)
  const[incorrect,setincorrect]=useState(0)
  const[extra,setextra]=useState(0)
  const[missedchar,setmissedchar]=useState(0)
  const[graphdata,setgraphdata]=useState([])

  console.log("inputRef",inputRef)

    function focusFunction()
    {
      inputRef.current.focus()
    }

    const calculateWPM = ()=>{
      return Math.round((correctchars/5)/(testTime/60))
    }

    const calculateAccuracy =()=>{
        return Math.round((correctwords/currWordIndex)*100)
    }

    //selecting time
    useEffect(()=>{
     resetTest();
    },[testTime])
    useEffect(()=>{
      wordspanref[0].current.childNodes[0].className='current'
      focusFunction()
    },[])

    const startTimer =()=>{
      const intervalId=setInterval(timer,1000)
      setintervalId(intervalId)
      function timer(){
        setcountDown((currCountDown) => {
          setcorrectchars((correctChars) => {
            setgraphdata((currGraphData) => {
              return [
                ...currGraphData,
                [
                  testTime - currCountDown + 1,
                  correctChars / 5 / ((testTime - currCountDown + 1) / 60),
                ],
              ];
            });
  
            return correctChars;
          });

          if(currCountDown === 1)
          {
            clearInterval(intervalId)
            settestEnd(true)
            return 0;
          }
            return currCountDown-1
        })
      }
    }
    const resetTest =()=>{
      clearInterval(intervalId)
      setcountDown(testTime)
      setCurrWordIndex(0)
      setcurrCharIndex(0)
      settestStart(false)
      settestEnd(false)
      setwords(randomWords(500))
      resetWordSpanRef();
      setcorrectchars(0);
      setincorrect(0);
      setmissedchar(0);
      setextra(0);
      setgraphdata([]);
      setcorrectwords(0)

    }

    const resetWordSpanRef=()=>{
      wordspanref.map(i =>{
       Array.from(i.current.childNodes).map(j=>{
        j.className = '';
       }) 
      })
      wordspanref[0].current.childNodes[0].className='current'
    }

    const handleUserInput=(e)=>{
      console.log(e.key)
      /*console.log(wordspanref[currWordIndex].current.childNodes[currCharIndex].innerText)*/
      if(!testStart)
      {
      startTimer();
      settestStart(true)
      }
      let allChildSpan=wordspanref[currWordIndex].current.childNodes
      console.log(allChildSpan)
      if(e.keyCode === 32)
      {
        const correctSpans =
        wordspanref[currWordIndex].current.querySelectorAll(".correct");
          if(correctSpans.length === allChildSpan.length)
          {
            setcorrectwords(correctwords+1)
          }
        if(allChildSpan.length<=currCharIndex){
          // cursor present at the end
          allChildSpan[currCharIndex-1].classList.remove('current-right');
        }
       else{
        setmissedchar(missedchar + (allChildSpan.length-currCharIndex))
        for(let i=currCharIndex;i<allChildSpan.length;i++){
          allChildSpan[i].className+=' skipped'
        }
        allChildSpan[currCharIndex].classList.remove('current')
       }
        setCurrWordIndex(currWordIndex+1)
        setcurrCharIndex(0)
        return
      }
       if(wordspanref[currWordIndex+1].current.offsetLeft < wordspanref[currWordIndex].current.offsetLeft)
       {
        wordspanref[currWordIndex].current.scrollIntoView();
       }

      if(e.keyCode === 8){

        if(currCharIndex!==0){
  
          if(currCharIndex === allChildSpan.length){
            if(allChildSpan[currCharIndex-1].className.includes('extra')){
              allChildSpan[currCharIndex-1].remove();
              allChildSpan[currCharIndex-2].className+=' current-right';
            }
            else{
              allChildSpan[currCharIndex-1].className = 'current';
            }
            
            setcurrCharIndex(currCharIndex-1);
            return;
          }
          allChildSpan[currCharIndex].className = '';
          allChildSpan[currCharIndex-1].className = 'current';
          setcurrCharIndex(currCharIndex-1);
        }
  
        return;
      }

      if(currCharIndex === allChildSpan.length)
      {
        setextra(extra+1)
        let newSpam =document.createElement('span');
        newSpam.innerText=e.key;
        newSpam.className='incorrect current-right extra'
        wordspanref[currWordIndex].current.append(newSpam)
        allChildSpan[currCharIndex-1].classList.remove('current-right')
        setcurrCharIndex(currCharIndex+1)
        return;
      }

      if(e.key === allChildSpan[currCharIndex].innerText)
      {
        allChildSpan[currCharIndex].className='correct'
        setcorrectchars(correctchars+1)
      }
      else
      {
        allChildSpan[currCharIndex].className='incorrect'
        setincorrect(incorrect+1)
      }

      if(currCharIndex+1 === allChildSpan.length)
        {
          allChildSpan[currCharIndex].className+=' current-right'
        }
        else
        {
          allChildSpan[currCharIndex+1].className='current'
        }
     
      setcurrCharIndex(currCharIndex+1)
    }

    const wordspanref=Array(100).fill(0).map(i=>createRef())
    console.log("wordspanref",wordspanref)
    const [words,setwords]=useState(()=>{
      return randomWords(500);
    })
    // console.log("words",words)
  return (
    <div>
    {(testEnd)?(<Stats wpm={calculateWPM()} 
                        Accuracy={calculateAccuracy()} 
                        correctchars={correctchars} 
                        incorrect={incorrect}
                        missedchar={missedchar}
                        extra={extra}
                        graphdata={graphdata}
                        resetTest={resetTest}
                        />):(
      <>
     <Uppermenu countDown={countDown} />
      <div className='type-box' onClick={focusFunction}>
      <div className='words-wrapper'>
      {words.map((words,index)=>(
         <span className='word' ref={wordspanref[index]}>
              {words.split('').map(char=>(
                  <span >
                      {char}
                  </span>
    ))}
         </span>
      ))}
      </div>
      </div>
      <input ref={inputRef} type='text' onKeyDown={handleUserInput} className='hidden-input'/>
      </>
    )}
    
    </div>
    
  )
}
export default TypingBox
